import { RequestStatus } from 'clickNgo/configs/service/common'

import { IShareOfBusinessState } from './models/IShareOfBusinessState'

export const initialState: IShareOfBusinessState = {
  data: {
    a3: {
      hpBrand: 0,
      allBrands: 0,
      topVendorBrand1: {
        name: '',
        spend: 0,
      },
      topVendorBrand2: {
        name: '',
        spend: 0,
      },
      topVendorBrand3: {
        name: '',
        spend: 0,
      },
      otherBrandSpend: 0,
      previousUnits: 0,
    },
    a4: {
      hpBrand: 0,
      allBrands: 0,
      topVendorBrand1: {
        name: '',
        spend: 0,
      },
      topVendorBrand2: {
        name: '',
        spend: 0,
      },
      topVendorBrand3: {
        name: '',
        spend: 0,
      },
      otherBrandSpend: 0,
      previousUnits: 0,
    },

    calculateHPBrandsOverLastYears: null,

    averageVolumePerDeviceAllBrands: 0,
    averageVolumePerDeviceHP: 0,

    monthlyInvoicedPagesAllBrands: 0,
    monthlyInvoicedPagesHP: 0,

    lastFinancialYearRevenuesAllBrands: 0,
    lastFinancialYearRevenuesHP: 0,

    contractualCustomerCountAllBrands: 0,
    contractualCustomerCountHP: 0,

    phyContractualUnitsA3: 0,
    phyContractualUnitsA4: 0,
    phyContractualUnitsTotal: 0,
    p5yContractualUnitsA3: 0,
    p5yContractualUnitsA4: 0,
    p5yContractualUnitsTotal: 0,
    mifUpdateRequired: null,
  },
  status: RequestStatus.FULFILLED,
  message: '',
}
